
















































































































import moment from 'moment';
import DictMixin from '@/mixins/dict-mixin';
import DatacollectServices from '@/services/datacollect';
import { mixins } from 'vue-class-component';
import { Component, Watch } from 'vue-property-decorator';
import MenuMixin from '@/mixins/menu-mixin';
//import FlowPanel from '../../components/ef/panel.vue'

@Component({
  components: { }
})
export default class DatacollectDetail extends mixins(DictMixin, MenuMixin) {
  dcSrv = new DatacollectServices();
  visible = false;
  id: any = 0;
  info = {};
  triggerModeStr = '';
  dateStr = '';

  created() {
    this.id = this.$route.query.id;
  }

  @Watch('$route')
  onRouteChange() {
    this.id = this.$route.query.id;
    this.onIdChange();
  }

  @Watch('id')
  async onIdChange() {
    if (!this.id || this.$route.path != '/data/datacollect/detail') return false;
    this.spinning = true;
    let res = await this.dcSrv.getInfo(this.id);
    this.spinning = false;
    this.info = res;

    if(res.batchJobInfo?.triggerMode === 0) {
      this.triggerModeStr = '手动'
    } else if(res.batchJobInfo?.triggerMode === 1) {
      this.triggerModeStr = '定时'
    } else if(res.batchJobInfo?.triggerMode === 2) {
      this.triggerModeStr = '周期'
    }

    if(res.tunnelInfo && res.tunnelInfo.startupTimestamp) {
      let date = new Date(res.tunnelInfo.startupTimestamp);
      let year = date.getFullYear();
      let month = date.getMonth()  < 10 ? '0' + date.getMonth() : '' + date.getMonth();
      let day = date.getDay() < 10 ? '0' + date.getDay() : '' + date.getDay();
      let hour = date.getHours()  < 10 ? '0' + date.getHours() : '' + date.getHours();
      let minute = date.getMinutes()  < 10 ? '0' + date.getMinutes() : '' + date.getMinutes();
      let second = date.getSeconds()  < 10 ? '0' + date.getSeconds() : '' + date.getSeconds();
      this.dateStr = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    }

  }

  bodyStyle = { backgroundColor: '#EEE' };

  columns = [
    { title: '数据源对象名', dataIndex: 'sourceTable', key: 'sourceTable', customRender: (text: any, row: any, index: number) => {
         const obj = {
            children: text,
            attrs: {},
          };
          if (index === 0) {
            // TODO 设置最大值
            this.$set(obj.attrs, 'rowSpan', 9999);
          } else {
            this.$set(obj.attrs, 'rowSpan', 0);
          }
          return obj;
    } },
    { title: '数据源字段物理名', dataIndex: 'sourceColumnNameEn', key: 'sourceColumnNameEn' },
    { title: '数据源字段逻辑名', dataIndex: 'sourceColumnNameCn', key: 'sourceColumnNameCn' },
    { title: '目标端对象名', dataIndex: 'sinkTable', key: 'sinkTable' , customRender: (text: any, row: any, index: number) => {
         const obj = {
            children: text,
            attrs: {},
          };
          if (index === 0) {
            // TODO 设置最大值
            this.$set(obj.attrs, 'rowSpan', 9999);
          } else {
            this.$set(obj.attrs, 'rowSpan', 0);
          }
          return obj;
    } },
    { title: '目标端字段物理名', dataIndex: 'sinkColumnNameEn', key: 'sinkColumnNameEn' },
    { title: '目标端字段逻辑名', dataIndex: 'sinkColumnNameCn', key: 'sinkColumnNameCn' }
  ];

}
